define('views/modals/goods-card/index',['require','jquery','underscore','chaplin','mediator','views/base/modal','views/modals/goods-card/content','models/pages/trade/basket-item'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        Chaplin = require('chaplin'),
        mediator = require('mediator'),
        ModalView = require('views/base/modal'),
        GoodsCardModalContentView = require('views/modals/goods-card/content'),
        BasketItemModel = require('models/pages/trade/basket-item');


    var GoodsCardModalView = ModalView.extend({
        listen: {
            'action model': 'handleAction'
        },
        initialize: function() {
            ModalView.prototype.initialize.apply(this, arguments);

            this.model.content.on('addToBasket model', _.bind(this.handleAddToBasket, this));
            this.model.content.on('updateBasketByFlashOrder model', _.bind(this.updateBasketByFlashOrder, this));
            this.model.content.on('leaveHide model', _.bind(this.onLeaveHide, this));
            this.model.content.on('close model', _.bind(this.onClose, this));
        },
        onLeaveHide: function(value){
            this.model.set('leaveHide', value);
        },
        onClose: function(){
            this.model.dispose();
        },
        render: function() {
            ModalView.prototype.render.apply(this, arguments);
            $('html').addClass('modal-visible');
            this.subview('content', new GoodsCardModalContentView({ model: this.model.content }));
        },
        updateBasketByFlashOrder: function(){
            var contentModel = this.model.content;

            var item = contentModel.attributes;
            item.idTrade = this.model.get('tradeId');
            item.idTradeGoods = item.tradeGoodsId;
            item.idOrganizationOffer = item.organizationOfferId;

            this.publishEvent('updateBasketByFlashOrder', item);
        },
        handleAddToBasket: function(){
            var _this = this;
            var contentModel = this.model.content;
            var basketId = contentModel.get('basketId');
            var item = contentModel.attributes;
            item.comment = $('#goods-card-comment').val();

            var basketAmount = item.basketAmount;

            item.idTrade = this.model.get('tradeId');
            item.idTradeGoods = item.tradeGoodsId;
            item.idOrganizationOffer = item.organizationOfferId;
            item.amount = basketAmount;
            item.price = item.traderBasePrice;

            var basketModel = new BasketItemModel(item);

            var itemClon = _.cloneDeep(item);

            var cb = function(eventName, bItem){
                var modal = this;
                return function(model){
                    bItem.id = model.get('id');
                    modal.publishEvent(eventName, bItem);
                    modal.model.dispose();
                };
            };
            cb = _.bind(cb, this);

            if (basketId) {
                itemClon.id = basketId;
                basketModel.set('id', basketId);
                if (basketAmount === 0) {
                    basketModel.destroy({ success: cb('removeFromBasket', itemClon) });
                } else {
                    basketModel.save({}, { success: cb('updateBasket', itemClon) });
                }
            } else {
                if (basketAmount > 0) {
                    itemClon.id = null;
                    basketModel.set('id', null);
                    basketModel.save({}, { success: cb('addToBasket', itemClon) });
                }
            }
        },
        handleAction: function(action, cancel) {
            var content = this.model.content;

            var basketId = content.get('basketId');

            if (action === 'cancel' && basketId && content.get('basketAmount') === 0){
                this.handleAddToBasket();
                cancel();
            }
        },
        dispose: function() {
            if (this.disposed) { return; }

            $('html').removeClass('modal-visible');

            ModalView.prototype.dispose.apply(this, arguments);
        }
    });

    return GoodsCardModalView;
});

